// UserConnectedHostsView.jsx
import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import useAPI from "../../../../../../api/hooks/useAPI";
import { ComplexEntityTypes } from "../../../../../../utils/constants";
import IntegrationImage from "../../../../integrations/components/IntegrationImage";
import { useEntities } from "../../../hooks/useEntities";
import EntityDrawer from "../../EntityDrawer/EntityDrawer";
import TextIntegrationStyle from "../../TextIntegrationStyle";
import { getUserConnectedHostsRows } from "./checkRowsUserData";

const UserConnectedHostsView = ({ entityData }) => {
  const [rows, setRows] = useState([]);
  const { useQueryForEntitiesByType } = useEntities();

  const { trackEvent } = useAPI();
  const [isHostDrawerOpen, setIsHostDrawerOpen] = useState(false);
  const [clickedHostEntity, setClickedHostEntity] = useState(null);

  const onHostClick = (cellParams) => {
    trackEvent(
      `User clicked on host ID ${cellParams?.row?.hostId}, from user connected hosts view ${entityData?.display_name}`
    );
    setIsHostDrawerOpen(true);
    setClickedHostEntity(cellParams?.row?.entityObj);
  };

  const { data: hostEntities } = useQueryForEntitiesByType({
    type: ComplexEntityTypes.HOST,
  });

  useEffect(() => {
    setRows(getUserConnectedHostsRows(entityData, hostEntities));
  }, [entityData, hostEntities]);

  return (
    rows.length > 0 && (
      <Box display={"flex"} flexDirection={"column"} gap={1}>
        {rows.map((row) => (
          <TextIntegrationStyle
            title={
              <Box
                display={"flex"}
                flexDirection={"row"}
                alignItems={"center"}
                gap={1}
              >
                {row.source.map((source, index) => (
                  <IntegrationImage
                    key={index}
                    name={source}
                    width={"16px"}
                    newLogo={true}
                  />
                ))}
              </Box>
            }
            value={row?.entityObj?.display_name}
            onClick={() => onHostClick({ row })}
            style={{
              cursor: "pointer",
              textDecoration: "underline",
            }}
            tooltipTitle={"Click to view host details"}
          ></TextIntegrationStyle>
        ))}

        {/* <StyledDataGrid columns={columnsToShow} rows={rows} /> */}
        <EntityDrawer
          openDrawer={isHostDrawerOpen && clickedHostEntity}
          selectedEntity={clickedHostEntity}
          onClose={() => {
            setIsHostDrawerOpen(false);
          }}
        />
      </Box>
    )
  );
};

export default UserConnectedHostsView;
